/*
 * Public API Surface of sp-select
 */

// export * from './lib/sp-select.service';
// export * from './lib/sp-select.component';
// export * from './lib/sp-select.module';




export { DropdownPosition, SpSelectComponent, SELECTION_MODEL_FACTORY } from './lib/sp-select.component';
export { SpSelectModule } from './lib/sp-select.module';
export { SpOption } from './lib/sp-select.types';
export { SelectionModel } from './lib/selection-model';
export { SpSelectConfig } from './lib/config.service';

export * from './lib/sp-templates.directive';
export * from './lib/ng-option.component';